module.exports = __webpack_public_path__ + "static/entrance-c99679a0b6904f65de388925b5004de2.jpg";